import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Media } from '../../../../../theme/Media';
import Icons from '../../../../Elements/Icons';
import { DropdownList } from '../../../DropdownList';
import { TableActionButton } from '../TableActionButton';
export const TableDropdownList = memo(function TableDropdownList({ zIndex = 10, buttonLabel = 'More', buttonDataTestId, isLoading, ...restProps }) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    return (_jsx(DropdownList, { zIndex: zIndex, isLoading: isLoading, renderButton: (isShown) => (_jsxs(TableActionButton, { dataTestId: buttonDataTestId, disabled: restProps.disabled, isLoading: isLoading, children: [_jsx(Icons.More, { size: 20, active: isShown }), isMobile && buttonLabel] })), ...restProps }));
});
